import React from 'react';

import ReactDOM from 'react-dom/client';

import App from './App';
import { defaultsHeadersAxios } from './services/apiService';
import { AUTH_TOKEN } from 'utils/constants';
import { getItemStorage } from 'utils/persistenceUtils';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

const token = getItemStorage(AUTH_TOKEN);

defaultsHeadersAxios(token || '');

root.render(<App />);
